import * as React from 'react';
import { withIntent } from '../../../../../util/hoc/withIntent.js';
import { useTimelineContext } from '../../../context/TimelineContext.js';
import { StaticHorizontalStep as StaticHorizontalStepMemoized } from '../shared/HorizontalStep/StaticHorizontalStep/StaticHorizontalStep.js';
import { StaticVerticalStep as StaticVerticalStepMemoized } from '../shared/VerticalStep/StaticVerticalStep/StaticVerticalStep.js';

var BaseStaticStep = function BaseStaticStep(props) {
  var _useTimelineContext = useTimelineContext(),
    direction = _useTimelineContext.direction;
  return direction === 'horizontal' ? /*#__PURE__*/React.createElement(StaticHorizontalStepMemoized, props) : /*#__PURE__*/React.createElement(StaticVerticalStepMemoized, props);
};
var ThemableStaticStep = withIntent(BaseStaticStep);
var StaticStep = /*#__PURE__*/React.memo(ThemableStaticStep);

export { ThemableStaticStep as BaseStaticStep, StaticStep };
//# sourceMappingURL=StaticStep.js.map
